module.exports = "/_next/static/images/254d5fe2700411cd11e672733028632c-woman-holding-card-smiling-2@desktop1024.png";